module.exports = __webpack_public_path__ + "static/ML-ceba20f866b93327c6d62dc3e7688fc6.jpg";